<template>
	<div class="blog">
		<fluke-card>
			<header>
				<div class="title">
					Comentários
				</div>
				<div class="description">
					Lista de todos os comentários
				</div>
			</header>
			<main>
				<h2>Esperando aprovação</h2>

				<v-data-table
					:headers="headers"
					:items="peding_comments"
					:rows-per-page-items="[5,10,50]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables">

					<template v-slot:items="props">
						<td class="cm_list_table_text_c">
							<div class="cm_name"><span>Nome:</span> {{ props.item.name }}</div>
							<div class="cm_name"><span>Email:</span> {{ props.item.email }}</div>
							<div class="cm_date"><span>Data:</span> {{ props.item.created_at }}</div>
							<div class="cm_cm">
								<span>Comentário:</span><br>
								{{ props.item.comment }}</div>
						</td>
						<td class="cm_list_table_action_c">
							<a @click="setApproved(props.item.id,true)"><i class="material-icons">check</i></a>
							<a @click="remove(props.item.id)"><i class="material-icons">close</i></a>
						</td>
					</template>
				</v-data-table>


				<hr>

				<h2>Todos</h2>

				<v-data-table
					:headers="headers"
					:items="notpeding_comments"
					:rows-per-page-items="[15,30,60]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables">

					<template v-slot:items="props">
						<td class="cm_list_table_text_c">
							<div class="cm_name"><span>Nome:</span> {{ props.item.name }}</div>
							<div class="cm_name"><span>Email:</span> {{ props.item.email }}</div>
							<div class="cm_date"><span>Data:</span> {{ props.item.created_at }}</div>
							<div class="cm_cm">
								<span>Comentário:</span><br>
								{{ props.item.comment }}</div>
						</td>
						<td class="cm_list_table_action_c">
							<a @click="setApproved(props.item.id,false)"><i class="material-icons">remove_circle_outline</i></a>
							<a @click="remove(props.item.id)"><i class="material-icons">close</i></a>
						</td>
					</template>
				</v-data-table>
			</main>
		</fluke-card>
	</div>
</template>

<script>
import axios from 'axios'
import Card from '../../../components/Main/Content/Card/Card.vue';
import SideCard from '../../../components/Main/Content/SideCard/SideCard.vue';
import Button from '../../../components/Main/Content/Button/Button.vue';

export default {
	data () {
		return {
			peding_comments: [],
			notpeding_comments: [],
			headers: [
				{
					text: "Comentário",
					align: 'left',
					value: 'created_at'
				},
				{
					text: "",
					align: 'right',
					value: ''
				},
			]
		}
	},
	components: {
		'fluke-card': Card,
		'fluke-side-card': SideCard,
		'fluke-button': Button
	},
	created () {
		this.loadData();
	},
	methods: {
		loadData: function(){
			this.getPedingComments();
			this.getComments();
		},
		getPedingComments: function() {
			axios
				.get( this.$myServerAddresses.blog + 'comments/peding', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                })
				.then( result => {
					this.peding_comments = result.data;
				});
		},
		getComments: function()
		{
			axios
				.get( this.$myServerAddresses.blog + 'comments/notpeding', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                })
				.then( result => {
					this.notpeding_comments = result.data;
				});
		},
		edit: function( index ) {
			this.$router.push({ name: 'blog-categories-edit', params: { id: index } });
		},
		categories: function() {
			this.$router.push({ name: 'blog-categories' });
		},
		setApproved: function( comment_id, is_approved ) {
			axios
				.put( this.$myServerAddresses.blog + 'comments/setpending',{
					peding_status: is_approved?1:0,
					id: comment_id
				}, {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                })
				.then( result => {
					this.loadData();
				});
		},
		remove: function( comment_id )
		{
			if(confirm('Remover?'))
			{
				axios
					.delete(
						this.$myServerAddresses.blog + 'comments/' + comment_id,
						{
							headers: {
								'X-Fluke': this.$cookies.get('token')
							}
						}
					)
					.then( result => {
						this.loadData();
					});
			}
		}
	}
}
</script>

<style lang="scss">
.cm_list_table_text_c {
	span {
		font-weight: 500;
	}
}
.cm_list_table_action_c {
	text-align: right;
	a {cursor: pointer; }
}
</style>

